export enum MessagingProviderType {
    Email = 'email',
    Sms = 'sms',
    Push = 'push',
}